import { FC } from 'react';

import { ICommonResponse } from 'api/types';
import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splittedDataToSortedArray } from 'containers/pdfStudent/utils';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionEducation } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { IEntity } from 'types';
import { getAcademicYearByDate, getDataLoadRequests, isDateValid } from 'utils';

import { professionAdditionalEducationSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const splitAdditionalEducationByAcademicData = (data: ICommonResponse<IEntity>, academicYears: string[]) => {
  const learningYearData: Record<string, IEntity[]> = {};

  data.content.forEach((item) => {
    // Если не задана дата события, то выставляем последний (текущий) учебный год
    const date = item?.formData?.eventDate ? new Date(item?.formData?.eventDate) : new Date();
    if (isDateValid(date)) {
      const period = getAcademicYearByDate(date);
      if (academicYears.includes(period)) {
        if (learningYearData[period]) {
          learningYearData[period].push(item);
        } else {
          learningYearData[period] = [item];
        }
      }
    }
  });

  return splittedDataToSortedArray(learningYearData);
};

const PdfAdditionalEducationContainer: FC = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const additionalEducation = useAppSelector(professionAdditionalEducationSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().professionEducation });

  const hasData = additionalEducation.content.length > 0;

  const academicYearData = splitAdditionalEducationByAcademicData(additionalEducation, academicYears);
  return (
    <PdfCommonDataEntityContainer title="Профессиональное обучение" Icon={IconWidgetProfessionEducation}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfAdditionalEducationContainer;
